import { Component, OnInit, ElementRef, ViewChild, Inject } from '@angular/core';
import * as Chartist from 'chartist';

import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';

import { interval } from 'rxjs';

import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { formatDate } from "@angular/common";

import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { ReponseWebService } from '../datastruct/Meloyi.module';
import { DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { DetailCommandeComponent } from '../detail-commande/detail-commande.component';

import { ExcelService } from '../excel.service';

import { GestockService } from '../services/gestock.service';
import { DashboardserviceService } from '../services/dashboardservice.service';

import { saveAs } from 'file-saver';



const source = interval(120000);

const httpOptions = {
  headers: new HttpHeaders(
    {
        'Content-Type' : 'application/x-www-form-urlencoded; charset=UTF-8'
    }
  )
};

const httpOptionsII = {
  headers: new HttpHeaders(
    {
        'Content-Type' : 'application/x-www-form-urlencoded; charset=UTF-8'
    }
  )
};




@Component({
  selector: 'app-detail-stock-stat',
  templateUrl: './detail-stock-stat.component.html',
  styleUrls: ['./detail-stock-stat.component.css']
})
export class DetailStockStatComponent implements OnInit {

  displayedColumns = [ 'produit', 'categorie', 'qte_en_stock'] ;

  displayedColumnsClients = [ 'fullName', 'phone', 'nompoint' ] ;

  handleError : any ;
   commands : any[] ;
   commandsLastWeek : any[] ;
   commandsCurrentWeek : any[] ;
   nbreCmds = 0 ;
   revenus = 0 ;
   panierMoyen = 0 ;
   totalLivraison = 0 ;
   subscription : any ;

  boutiques: any; //string[] = ['Toutes', 'Boutique A', 'Boutique B'];
  selectedBoutique: string = 'Toutes';


  allTheCompagnies
  choosencompagnieID
  vientDechooseCompagnie



   longTotal = 0 ; 
   redLine = 0 ;
   OrangeLine = 0 ;
   blueLine = 0 ;
   greenLine = 0 ;


  nvllesCmds = 0 ;
  preparing = 0 ;
  enlivraison = 0 ; 
  livrees = 0 ;

  ourFirstday  : any ;
  firstDayOfLastWeek : any ;
  lastDayOfLastWeek : any ;

  firstDayOfMonth : any ;

  today = new Date() ;

  dataSource = new MatTableDataSource<any>([]);
  weekday = [];

  avenantsYeup : any ;

  @ViewChild('myDiv') myDiv: ElementRef ;

  
  // commands = [] ;

  choosencompagnieName = "" ;

  excelData   = [];
  

  allDetailedTransacts : any ;

  datedeb : any ;
  datefin : any ;

  commissions = "-" ;
  plafondDispo : any ; ;
  localcompliances  : any ;


  dateRange = {
    start: new Date(new Date().setMonth(new Date().getMonth() - 1)),
    end: new Date()
  };

  stockRotation : any;
  dormantProducts = 0;
  stockValue = 0;
  availabilityRate = 0;

  userchoice = 1 ;

  samacaabiyoonwii = "" ;

  choosenReport = 'Historique Conversion Manuelles' ;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  retourClientWS  : ReponseWebService ;


  filteredData : any ;

  toExport : any ;

  categories = ["Toutes"] ;

  newCategory : any ;

  optionChoisie : any ;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private dashboardService: DashboardserviceService, 
    private excelService: ExcelService, private httpClient: HttpClient,
    public dialog: MatDialog,  private configServer: GestockService,
     private _adapter: DateAdapter<any>, public dialogRef: MatDialogRef<DetailStockStatComponent>,
      @Inject(MAT_DATE_LOCALE) private _locale: string) { 

    this.dateRange = data.element.dateRange ;
    this.optionChoisie = data.element.optionChoisie ;
    this.selectedBoutique = data.element.selectedBoutique ;
    this.boutiques = data.element.boutiques ;
  }


  ngOnInit() {
    this.samacaabiyoonwii = sessionStorage.getItem("samacaabiyoonwii") ;
    let profil = sessionStorage.getItem("profil") ;
    this.localcompliances = JSON.parse(sessionStorage.getItem("compliances")) ;

    this.datedeb = this.dateRange.start.toISOString().split('T')[0] ;
    this.datefin = this.dateRange.end.toISOString().split('T')[0] ;

    this.getChoosenOptionData();
  }


	ngAfterViewInit() {
	  this.dataSource.paginator = this.paginator;
	  this.dataSource.sort = this.sort;
	}

  onBoutiqueChange(): void {
    this.getChoosenOptionData();
  }

  onDateChange(): void {
    this.getChoosenOptionData();
  }



  close(){
    this.dialogRef.close();
  }



  getAllCategories(){
    this.configServer.getAllCategories(this.samacaabiyoonwii).then( (retourbi) => {
      this.retourClientWS = retourbi ;
      console.log(this.retourClientWS.data) ;
      var statutreq = this.retourClientWS.statutreq;
      if(statutreq==1){
        this.categories = ["Toutes"] ;
        for (var i = 0; i < this.retourClientWS.data.length; i++) {
          this.categories.push(this.retourClientWS.data[i].nomcategorie)  ;
        }
        console.log("Done") ;
      }
      else{
        console.log("Failed") ;
      }
    }) ;        
  }

  getChoosenOptionData(){
    if(this.optionChoisie=="dormant")
      this.getProduitsDormant();
    if(this.optionChoisie=="clientDormant")
      this.loadClientsDormant();
  }

  afficheOption(){
    if(this.optionChoisie=="dormant")
     return "Stock Dormant" ;
    if(this.optionChoisie=="clientDormant")
     return "Clients Dormants" ;
  }

  loadClientsDormant(){
   let date_debut = this.dateRange.start.toISOString().split('T')[0] ;
   let date_fin = this.dateRange.end.toISOString().split('T')[0] ;
    this.dashboardService.loadClientsDormant(this.samacaabiyoonwii, this.selectedBoutique, date_debut, date_fin ).then( (res) => {
        console.log(res);
        if (res.statutreq === 1) {
          this.dataSource = new MatTableDataSource( res.data );
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
          this.toExport = res.data ;
        } else {
          console.warn('Erreur serveur:', res.message);
        }
    }) ;        
  }

  getProduitsCritiques(){
   let date_debut = this.dateRange.start.toISOString().split('T')[0] ;
   let date_fin = this.dateRange.end.toISOString().split('T')[0] ;
    this.dashboardService.getProduitsCritiques(this.samacaabiyoonwii, this.selectedBoutique, date_debut, date_fin ).then( (res) => {
        console.log(res);
        if (res.statutreq === 1) {
          this.dataSource = new MatTableDataSource( res.data );
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
          this.toExport = res.data ;
        } else {
          console.warn('Erreur serveur:', res.message);
        }
    }) ;        
  }

  getProduitsDormant(){
   let date_debut = this.dateRange.start.toISOString().split('T')[0] ;
   let date_fin = this.dateRange.end.toISOString().split('T')[0] ;
    this.dashboardService.getProduitsDormant(this.samacaabiyoonwii, this.selectedBoutique, date_debut, date_fin ).then( (res) => {
        console.log(res);
        if (res.statutreq === 1) {
          this.dataSource = new MatTableDataSource( res.data );
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
          this.toExport = res.data ;
        } else {
          console.warn('Erreur serveur:', res.message);
        }
    }) ;        
  }



  getTMostSaledProducts(){
   let date_debut = this.dateRange.start.toISOString().split('T')[0] ;
   let date_fin = this.dateRange.end.toISOString().split('T')[0] ;
    this.dashboardService.getTMostSaledProducts(this.samacaabiyoonwii, this.selectedBoutique, date_debut, date_fin ).then( (res) => {
        console.log(res);
        if (res.statutreq === 1) {
          this.dataSource = res.data ;
          this.toExport = res.data ;
        } else {
          console.warn('Erreur serveur:', res.message);
        }
    }) ;        
  }

  getTopLeastSaledProducts(){
   let date_debut = this.dateRange.start.toISOString().split('T')[0] ;
   let date_fin = this.dateRange.end.toISOString().split('T')[0] ;
    this.dashboardService.getTopLeastSaledProducts(this.samacaabiyoonwii, this.selectedBoutique, date_debut, date_fin ).then( (res) => {
        console.log(res);
        if (res.statutreq === 1) {
          this.dataSource = res.data ;
          this.toExport = res.data ;
        } else {
          console.warn('Erreur serveur:', res.message);
        }
    }) ;        
  }

  getTopMostRentableProducts(){
   let date_debut = this.dateRange.start.toISOString().split('T')[0] ;
   let date_fin = this.dateRange.end.toISOString().split('T')[0] ;
    this.dashboardService.getTopMostRentableProducts(this.samacaabiyoonwii, this.selectedBoutique, date_debut, date_fin ).then( (res) => {
        console.log(res);
        if (res.statutreq === 1) {
          this.dataSource = res.data ;
          this.toExport = res.data ;
        } else {
          console.warn('Erreur serveur:', res.message);
        }
    }) ;        
  }


  getAllPoints(){

    this.configServer.getAllPoints(this.samacaabiyoonwii).then( (retourbi) => {
      this.retourClientWS = retourbi ;
      var statutreq = this.retourClientWS.statutreq;
      if(statutreq==1){
        console.log("Done") ;
        this.boutiques = this.retourClientWS.data ; 
        if(this.boutiques.length==1)
          this.selectedBoutique = this.boutiques[0].idPoint ;
        this.getAllTransactsByDateInterval() ;
      }
      else{
        console.log("Failed") ;
      }
    }) ;    
  }


  exportToExcel(): void {

    var debut = formatDate(this.datedeb, "yyyy-MM-dd", 'en-US');
    var fin = formatDate(this.datefin, "yyyy-MM-dd", 'en-US');

    let nomRapport = "" ;

    this.excelData = this.takeNeededData() ;

    nomRapport = this.afficheOption()+" "+this.selectedBoutique ;

    this.excelService.generateExcel(this.excelData, nomRapport);
  }

  takeNeededData(){
    if(this.optionChoisie=='dormant')
      return this.toExport.map((item, index) => ({
        "Produit": item.produit,
        "Catégorie": item.categorie,
        "Qté en Stock": this.getMontantFormatee(item.qte_en_stock)
      }));

    if(this.optionChoisie=='clientDormant')
      return this.toExport.map((item, index) => ({
        "Prenom-Nom": item.fullName,
        "Téléphone": item.phone,
        "Boutique": item.nompoint
      }));


  }


  getThisValueFromProps(valueName, propositionRetenue){
    for (var i = 0; i < propositionRetenue.allvalues.length; i++) {
      if(propositionRetenue.allvalues[i].nomvariable==valueName)
        return propositionRetenue.allvalues[i].valeur ;
    }
    return undefined ;
  }


  startAnimationForLineChart(chart){
      let seq: any, delays: any, durations: any;
      seq = 0;
      delays = 80;
      durations = 500;

      chart.on('draw', function(data) {
        if(data.type === 'line' || data.type === 'area') {
          data.element.animate({
            d: {
              begin: 600,
              dur: 700,
              from: data.path.clone().scale(1, 0).translate(0, data.chartRect.height()).stringify(),
              to: data.path.clone().stringify(),
              easing: Chartist.Svg.Easing.easeOutQuint
            }
          });
        } else if(data.type === 'point') {
              seq++;
              data.element.animate({
                opacity: {
                  begin: seq * delays,
                  dur: durations,
                  from: 0,
                  to: 1,
                  easing: 'ease'
                }
              });
          }
      });

      seq = 0;
  };
  startAnimationForBarChart(chart){
      let seq2: any, delays2: any, durations2: any;

      seq2 = 0;
      delays2 = 80;
      durations2 = 500;
      chart.on('draw', function(data) {
        if(data.type === 'bar'){
            seq2++;
            data.element.animate({
              opacity: {
                begin: seq2 * delays2,
                dur: durations2,
                from: 0,
                to: 1,
                easing: 'ease'
              }
            });
        }
      });

      seq2 = 0;
  };



   getInfosAssur(souscription){
     return JSON.parse( souscription.nomAssure ).prenom+" "+JSON.parse( souscription.nomAssure ).nom ;
   }


  getMontantFormatee(montant){
    let resultd = Number(montant).toLocaleString('fr-FR');
    return resultd ;
  }


  getAllCompagnies(){
    console.log("Here we go !!!") ;
    /*this.configServer.getAllCompagnies("thiswii").then( (retourbi) => {
      this.retourClientWS = retourbi ;
      var statutreq = this.retourClientWS.statutreq;

      this.getAvenantsYiAmYeupp() ;

      if(statutreq==1){
        console.log("Done") ;
        this.allTheCompagnies = this.retourClientWS.data ; 
      }
      else{
        console.log("Failed") ;
      }
    }) ;*/    
  }


  taneBenCompagnieSpecifique(oneidComp, indexcompagnie){
    if(oneidComp!=0){
      this.choosencompagnieID = oneidComp ;
      this.choosencompagnieName = this.allTheCompagnies[indexcompagnie].nomcompagnie ;
      this.vientDechooseCompagnie = 1 ;      
      this.applyFilterByValue(this.choosencompagnieName) ;
    }else{
      this.choosencompagnieName = "" ;
      this.applyFilterByValue("") ;
    }
  }


  getAllTransactsByDateInterval(){

    var debut = formatDate(this.datedeb, "yyyy-MM-dd", 'en-US');
    var fin = formatDate(this.datefin, "yyyy-MM-dd", 'en-US');

    this.configServer.getReporting(this.samacaabiyoonwii,  this.selectedBoutique, debut, fin).then( (retourbi) => {
      this.retourClientWS = retourbi ;
        console.log("Done") ;
        this.allDetailedTransacts = this.retourClientWS.data ;
        
        this.nbreCmds = this.allDetailedTransacts.length ;
        this.revenus = this.totalCmds(this.allDetailedTransacts) ;

        this.dataSource =  new MatTableDataSource(this.allDetailedTransacts) ;
        this.toExport = this.allDetailedTransacts ;
        this.filteredData = this.dataSource.data ;
        //setTimeout(()=>{
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
        //},1000)

        this.getAllCategories();

        //this.getBigChiffres() ;
     
    }) ; 
  }


  getAvenantsYiAmYeupp(){
    /*this.configServer.getAvenantsYiAmYeupp(this.samacaabiyoonwii).then( (retourbi) => {
      this.retourClientWS = retourbi ;
        console.log("Done") ;
        this.avenantsYeup = this.retourClientWS.data ;
        console.log(this.avenantsYeup) ;    
        this.getAllTransactsByDateInterval() ;         
    }) ;*/     
  }


  getBigChiffres(){
    /*this.configServer.getBigChiffres(this.samacaabiyoonwii).then( (retourbi) => {
      this.retourClientWS = retourbi ;
      console.log("Done BIGNUMBERS : ", this.retourClientWS, this.retourClientWS.data, this.localcompliances) ;
      if(this.retourClientWS.statutreq==1){
        this.commissions =  this.retourClientWS.data[0].commission ;
        for (var i = 0; i < this.localcompliances.length; i++) {
          if(this.localcompliances[i].name=="solde_impaye")
            this.plafondDispo =  Number(this.localcompliances[i].valeur) - Number(this.retourClientWS.data[0].montantAVerseDj) ;
        }
      }else{
        this.commissions = "-" ;
        this.plafondDispo  = undefined ;
      }

    }) ;*/         
  }

/*  {
    "operation": "solde_impaye",
    "regle": "max",
    "valeur": "250000"
*/

  


  parseThisElt(elt){
    return JSON.parse(elt) ;
  }


  getAllReprisesByDateInterval(){}


  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

  }


  applyFilterByValue(incomingFilterValue) {
    const filterValue = incomingFilterValue;
    this.dataSource.filter = filterValue.trim().toLowerCase();
    this.filteredData = this.dataSource.data.filter(item => item.nomcompagnie==incomingFilterValue);
    this.nbreCmds = this.filteredData.length ;
    this.revenus = this.totalCmds(this.filteredData) ;
  }


  public dataOnWeekBases(){
      this.remoteDataByInterv('https://kabire2.smkfinances.com/screens/getcommandesdashboardInterval.php', {'deb' : this.firstDayOfLastWeek, 'fin' : this.lastDayOfLastWeek}).subscribe({
            next: retourPost => {

              this.commandsLastWeek = retourPost ;


              console.log(this.commandsLastWeek);
              console.log("lastweek") ;

        this.remoteDataByInterv('https://kabire2.smkfinances.com/screens/getcommandesweekbi.php', {'deb' : this.ourFirstday}).subscribe({
              next: retourPost => {
                this.commandsCurrentWeek = retourPost ;

              console.log("thisweek") ;

              console.log(this.commandsCurrentWeek);

                this.weekday[0] =  "Dimanche";
                this.weekday[1] = "Lundi";
                this.weekday[2] = "Mardi";
                this.weekday[3] = "Mercredi";
                this.weekday[4] = "Jeudi";
                this.weekday[5] = "Vendredi";
                this.weekday[6] = "Samedi";

                let totalLundi = this.totalByDay(this.commandsLastWeek, 1) ;
                let totalMardi = this.totalByDay(this.commandsLastWeek, 2) ;
                let totalMercredi = this.totalByDay(this.commandsLastWeek, 3) ;
                let totalJeudi = this.totalByDay(this.commandsLastWeek, 4) ;
                let totalVendredi = this.totalByDay(this.commandsLastWeek, 5) ;
                let totalSamedi = this.totalByDay(this.commandsLastWeek, 6) ;
                let totalDimanche = this.totalByDay(this.commandsLastWeek, 0) ;

                let highestValuePasse = Math.max(totalLundi, totalMardi, totalMercredi, totalJeudi, totalVendredi, totalSamedi, totalDimanche) ;

                let totalLundiBii = this.totalByDay(this.commandsCurrentWeek, 1) ;
                let totalMardiBii = this.totalByDay(this.commandsCurrentWeek, 2) ;
                let totalMercrediBii = this.totalByDay(this.commandsCurrentWeek, 3) ;
                let totalJeudiBii = this.totalByDay(this.commandsCurrentWeek, 4) ;
                let totalVendrediBii = this.totalByDay(this.commandsCurrentWeek, 5) ;
                let totalSamediBii = this.totalByDay(this.commandsCurrentWeek, 6) ;
                let totalDimancheBii = this.totalByDay(this.commandsCurrentWeek, 0) ;

                let highestValueWkBii = Math.max(totalLundiBii, totalMardiBii, totalMercrediBii, totalJeudiBii, totalVendrediBii, totalSamediBii, totalDimancheBii) ;

                let highestValue = Math.max(highestValuePasse, highestValueWkBii) ;

                var data = {
                  series: [5, 3, 4]
                };

                var sum = function(a, b) { return a + b };

                var dailyFlowChart = new Chartist.Pie('.ct-chart', data, {
                  labelInterpolationFnc: function(value) {
                    return Math.round(value / data.series.reduce(sum) * 100) + '%';
                  }
                });

                const dataDailySalesChart: any = {
                    labels: ['L', 'M', 'M', 'J', 'V', 'S', 'D'],
                    series: [
                        [totalLundi, totalMardi, totalMercredi, totalJeudi, totalVendredi, totalSamedi, totalDimanche],
                        [totalLundiBii, totalMardiBii, totalMercrediBii, totalJeudiBii, totalVendrediBii, totalSamediBii, totalDimancheBii]
                    ]
                };

                const optionsDailySalesChart: any = {
                    lineSmooth: Chartist.Interpolation.cardinal({
                        tension: 0
                    }),
                    low: 0,
                    high: highestValue+10, // creative tim: we recommend you to set the high sa the biggest value + something for a better look
                    chartPadding: { top: 0, right: 0, bottom: 0, left: 0},
                }



                var dailySalesChart = new Chartist.Line('#dailySalesChart', dataDailySalesChart, optionsDailySalesChart);

                this.startAnimationForLineChart(dailySalesChart);


              },
              error: err => {console.log(err)},
              complete: () => console.log('DONE!')
        }) ;    

      },
      error: err => {console.log(err)},
      complete: () => console.log('DONE!')
    }) ;    
  }


  public opensnack() : void {
      this.remotedata('https://kabire2.smkfinances.com/screens/getcommandesdashboard.php', {}).subscribe({
            next: retourPost => {
              this.commands = retourPost ;

              this.nbreCmds = this.commands.length ;
              this.revenus = this.totalCmds(this.commands) ;
              this.panierMoyen = this.calculPanierMoyen(this.commands) ;
              this.totalLivraison = this.calculNbreLivraison(this.commands) ;


              this.nvllesCmds = this.totalCmdsByState(this.commands, 2) ;
              this.preparing = this.totalCmdsByState(this.commands, 3) ;
              this.enlivraison = this.totalCmdsByState(this.commands, 4) ;
              this.livrees = this.totalCmdsByState(this.commands, 5) ;


      /* ----------==========     Daily Sales Chart initialization For Documentation    ==========---------- */



            /* ----------==========     Completed Tasks Chart initialization    ==========---------- */

            const dataCompletedTasksChart: any = {
                labels: ['12p', '3p', '6p', '9p', '12p', '3a', '6a', '9a'],
                series: [
                    [230, 750, 450, 300, 280, 240, 200, 190]
                ]
            };

           const optionsCompletedTasksChart: any = {
                lineSmooth: Chartist.Interpolation.cardinal({
                    tension: 0
                }),
                low: 0,
                high: 1000, // creative tim: we recommend you to set the high sa the biggest value + something for a better look
                chartPadding: { top: 0, right: 0, bottom: 0, left: 0}
            }

            var completedTasksChart = new Chartist.Line('#completedTasksChart', dataCompletedTasksChart, optionsCompletedTasksChart);

            // start animation for the Completed Tasks Chart - Line Chart
            this.startAnimationForLineChart(completedTasksChart);



            /* ----------==========     Emails Subscription Chart initialization    ==========---------- */

            var datawebsiteViewsChart = {
              labels: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
              series: [
                [542, 443, 320, 780, 553, 453, 326, 434, 568, 610, 756, 895]

              ]
            };
            var optionswebsiteViewsChart = {
                axisX: {
                    showGrid: false
                },
                low: 0,
                high: 1000,
                chartPadding: { top: 0, right: 5, bottom: 0, left: 0}
            };
            var responsiveOptions: any[] = [
              ['screen and (max-width: 640px)', {
                seriesBarDistance: 5,
                axisX: {
                  labelInterpolationFnc: function (value) {
                    return value[0];
                  }
                }
              }]
            ];

            var websiteViewsChart = new Chartist.Bar('#websiteViewsChart', datawebsiteViewsChart, optionswebsiteViewsChart, responsiveOptions);

              //start animation for the Emails Subscription Chart
            this.startAnimationForBarChart(websiteViewsChart);


            this.longTotal =  (this.myDiv.nativeElement as HTMLElement).offsetWidth - 100 ;

            let allLineNum =  this.nvllesCmds + this.preparing + this.enlivraison + this.livrees;

            this.redLine = this.nvllesCmds * this.longTotal / allLineNum;
            this.OrangeLine = this.preparing * this.longTotal / allLineNum ;
            this.blueLine = this.enlivraison * this.longTotal / allLineNum ;
            this.greenLine = this.livrees * this.longTotal / allLineNum ;

            console.log(this.redLine) ;
            console.log(this.OrangeLine) ;
            console.log(this.blueLine) ;
            console.log(this.greenLine) ;

            },
            error: err => {console.log(err)},
            complete: () => console.log('DONE!')
      }) ;    
  }




  remotedata(url: string, user: any) {
      return this.httpClient.post<any[]>(url, user, httpOptions).pipe(catchError(this.handleError)) ;      
  }

  remoteDataByInterv(url: string, user: any) {
    return this.httpClient.post<any[]>(url, user, httpOptionsII);
  }

  totalCmds(ListCommands){
    let  total : number = 0 ;
    for (var i = ListCommands.length - 1; i >= 0; i--) {
      total = total + parseInt( ListCommands[i].MontantCmd) ;
     }
     return total ;
  }


  totalByDay(ListCommands, dayOrder){

    let total : number = 0 ;

    for (var i = ListCommands.length - 1; i >= 0; i--) {
      var theDayI = new Date(ListCommands[i].date);
      var day = theDayI.getDay();      
       if( day == dayOrder )
        total = total + parseInt(ListCommands[i].montant) ;
     }

     console.log(total) ;
     return total ;    
  }



  totalCmdsByState(ListCommands, etat){
    let  total : number = 0 ;
    for (var i = ListCommands.length - 1; i >= 0; i--) {
       if( parseInt( ListCommands[i].etat)==etat )
        total = total + 1 ;
     }

     console.log(etat.toString()+" - - - "+total.toString() ) ;
     return total ;    
  }



  calculPanierMoyen(commandsList){
    return Math.trunc( this.totalCmds(commandsList) / commandsList.length ) ;
  }

  calculNbreLivraison(ListCommands){
    let  total : number = 0 ;
    for (var i = ListCommands.length - 1; i >= 0; i--) {
       if( parseInt( ListCommands[i].etat)==5 )
        total = total + 1 ;
     }
     return total ;    
  }


}


 @Pipe({
   name: 'customDate'
 })
 export class CustomDatePipe extends 
              DatePipe implements PipeTransform {
   transform(value: any, args?: any): any {
     return super.transform(value, "EEEE d MMMM y h:mm a");
   }
 }

